/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Simple_Notsubscribeddesc2Inputs */

const id_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan notifikasi tentang pembaruan Epic Games Store, game gratis, dan banyak lagi`)
};

const ms_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan pemberitahuan tentang kemas kini Epic Games Store, permainan percuma, dan banyak lagi`)
};

const da_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få besked om Epic Games Store opdateringer, gratis spil og mere`)
};

const de_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erhalten Sie Benachrichtigungen über Epic Games Store-Updates, kostenlose Spiele und mehr`)
};

const en_us2_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get notified about Epic Games Store updates, free games, and more`)
};

const es_es2_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibe notificaciones sobre actualizaciones de la Epic Games Store, juegos gratis y más`)
};

const es_mx2_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibe notificaciones sobre actualizaciones de la Epic Games Store, juegos gratis y más`)
};

const fil_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maabisuhan tungkol sa mga update ng Epic Games Store, libreng laro, at marami pa`)
};

const fr_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soyez informé des mises à jour de l'Epic Games Store, des jeux gratuits et plus encore`)
};

const it_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricevi notifiche sugli aggiornamenti dell'Epic Games Store, giochi gratuiti e altro`)
};

const hu_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Értesülj az Epic Games Store frissítéseiről, ingyenes játékokról és többől`)
};

const nl_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontvang meldingen over Epic Games Store-updates, gratis games en meer`)
};

const no_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få varsler om Epic Games Store-oppdateringer, gratis spill og mer`)
};

const pl_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otrzymuj powiadomienia o aktualizacjach Epic Games Store, darmowych grach i nie tylko`)
};

const pt_br2_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get notified about Epic Games Store updates, free games, and more`)
};

const pt_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receba notificações sobre atualizações da Epic Games Store, jogos grátis e muito mais`)
};

const ro_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primește notificări despre actualizări Epic Games Store, jocuri gratuite și multe altele`)
};

const fi_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat ilmoituksia Epic Games Storen päivityksistä, ilmaispeleistä ja muusta`)
};

const sv_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få notiser om Epic Games Store-uppdateringar, gratis spel och mer`)
};

const vi_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhận thông báo về cập nhật Epic Games Store, game miễn phí và hơn thế nữa`)
};

const tr_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store güncellemeleri, ücretsiz oyunlar ve daha fazlası hakkında bildirim alın`)
};

const cs_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostávejte upozornění na aktualizace Epic Games Store, hry zdarma a další`)
};

const bg_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получавайте известия за актуализации на Epic Games Store, безплатни игри и други`)
};

const ru_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получайте уведомления об обновлениях Epic Games Store, бесплатных играх и многом другом`)
};

const uk_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отримуйте сповіщення про оновлення Epic Games Store, безкоштовні ігри тощо`)
};

const ar_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احصل على إشعارات حول تحديثات Epic Games Store والألعاب المجانية والمزيد`)
};

const hi_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store अपडेट, मुफ़्त गेम के बारे में सूचनाएँ प्राप्त करें`)
};

const th_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับการแจ้งเตือนเกี่ยวกับการอัปเดต Epic Games Store เกมฟรี และอื่น ๆ`)
};

const ja_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store の更新、無料ゲームなどの通知を受け取る`)
};

const zh_cn2_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get notified about Epic Games Store updates, free games, and more`)
};

const zh_hant1_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get notified about Epic Games Store updates, free games, and more`)
};

const ko_notifications_simple_notsubscribeddesc2 = /** @type {(inputs: Notifications_Simple_Notsubscribeddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store 업데이트, 무료 게임 등에 대한 알림을 받으세요`)
};

/**
* | output |
* | --- |
* | "Get notified about Epic Games Store updates, free games, and more" |
*
* @param {Notifications_Simple_Notsubscribeddesc2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_simple_notsubscribeddesc2 = /** @type {((inputs?: Notifications_Simple_Notsubscribeddesc2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Simple_Notsubscribeddesc2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "ms") return ms_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "da") return da_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "de") return de_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "en-US") return en_us2_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "es-ES") return es_es2_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "fil") return fil_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "fr") return fr_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "it") return it_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "hu") return hu_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "nl") return nl_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "no") return no_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "pl") return pl_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "pt") return pt_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "ro") return ro_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "fi") return fi_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "sv") return sv_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "vi") return vi_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "tr") return tr_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "cs") return cs_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "bg") return bg_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "ru") return ru_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "uk") return uk_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "ar") return ar_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "hi") return hi_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "th") return th_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "ja") return ja_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_simple_notsubscribeddesc2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_simple_notsubscribeddesc2(inputs)
	return ko_notifications_simple_notsubscribeddesc2(inputs)
});
export { notifications_simple_notsubscribeddesc2 as "notifications.simple.notSubscribedDesc" }